import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets} from 'chart.js';
import { MultiDataSet, Label,PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ResultadosService } from '../resultados.service';
import * as backInter from 'app/auth/auth-data.model';
// import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import Swal from 'sweetalert2';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {Router,ActivatedRoute} from "@angular/router"
import { FuseConfigService } from '@fuse/services/config.service';

@Component({
  selector: 'app-resultados4all',
  templateUrl: './resultados4all.component.html',
  styleUrls: ['./resultados4all.component.scss']
})
export class Resultados4allComponent implements OnInit {
  cargando = true;
  datosChange = false;
  porcentajeSatisfaccion:number;
  porcentajeConocimiento:number;

  seccionNumero:number;
  seccionesOcultas:boolean;
  resultados4ll: backInter.Resultados4all;
  resultadosDemograficos: backInter.Resultados4all;
  resultadosDemograficos2: backInter.Resultados4all;
  conocimientoAvance:any;
  satisfaccionAvance: any;
  styleElement: HTMLStyleElement;
  styleElement2: HTMLStyleElement;

  segmentosSeleccionados: backInter.segmentosDemograficos[];
  ///Grafica Demograficos
  barChartOptions: ChartOptions;
  barChartLabels: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartData : ChartDataSets[];
//////Grafica CONOCIMIENTO
 doughnutChartPluginsConocimiento: PluginServiceGlobalRegistrationAndOptions[];
 donutColorsConocimiento: any[];
 doughnutChartLabelsConocimiento: Label[] = [];
 doughnutChartDataConocimiento: MultiDataSet = [];
 doughnutChartOptionsConocimiento:any;
 doughnutChartType: ChartType = 'doughnut';


////Grafica Satisfaccion
doughnutChartPluginsSatisfaccion: PluginServiceGlobalRegistrationAndOptions[];
donutColorsSatisfaccion: any[];
doughnutChartLabelsSatisfaccion: Label[] = [];
doughnutChartDataSatisfaccion: MultiDataSet = [];
doughnutChartOptionsSatisfaccion:any;

  iconosBoton: any = [
    {nombre: 'Género', icono: 'wc'},
    {nombre: 'Condición de trabajo', icono: 'supervisor_account'},
    {nombre: 'Tipo de trabajo', icono: 'domain'},
    {nombre: 'Cargo homologado ', icono: 'card_travel'},
    {nombre: 'Años de Trabajo ', icono: 'date_range'},
    {nombre: 'Educación', icono: 'school'},
  ];
  iconoDefault: any = {nombre: 'default', icono: 'insert_chart_outlined'};
  iconosFiltrados: any[] = [];

  tokenEncuesta=localStorage.getItem('tokenEncuestaV3');
  idSurveyConfig=localStorage.getItem('idSurveyConfiguration4All');

  parametroTipoProducto: string;
  parametroProductoId: string;
  parametroEmpresaId: string;
  parametroToken: string;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private activatedRoute: ActivatedRoute,
    private _fuseConfigService: FuseConfigService,
    private resultadosService: ResultadosService,
    private translateSrv: TranslateService,
  ) {
    lang_resultados.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.activatedRoute.params.subscribe(params => {
      console.log(params);

      this.parametroTipoProducto = params.tipoProducto;
      this.parametroProductoId = params.idProducto;
      this.parametroEmpresaId = params.empresaId;
      this.parametroToken = params.token;
    });

  }

  ngOnInit() {
    if (this.parametroProductoId) {
      this._fuseConfigService.config = {
        layout: {
          navbar   : {hidden: true },
          toolbar  : {hidden: true },
          footer   : {hidden: false },
          sidepanel: {hidden: true }
        }
      };

      switch (this.parametroTipoProducto) {
        case '40': case '41': case '42': case '75':
        this.getresultallProducVersion3(this.parametroToken);
        break;

        default:
        console.log('no entro producto 3.0');

        this.getinfo4allExterno();

        break;
      }
      this.styleElement = document.createElement('style');
      this.styleElement2 = document.createElement('style');
      this.cambiaColorConocimientos();
      this.cambiaColorSatisfaccion();


    }else{
      switch (localStorage.getItem("tipoResultForall")) {
        case '40': case '41': case '42': case '75':
        this.getresultallProducVersion3(this.idSurveyConfig);
        break;

        default:
        console.log('no entro producto 3.0');

        this.getinfo4all();

        break;
      }
      this.styleElement = document.createElement('style');
      this.styleElement2 = document.createElement('style');
      this.cambiaColorConocimientos();
      this.cambiaColorSatisfaccion();

    }


  }


  cambiaColorConocimientos() {
    const head = document.getElementsByTagName('head')[0];
    let css='';
    css = css+`
    .prro .mat-progress-bar-fill::after {
      background-color: #087272 !important;
    }
    body.temaFocusArea2 .mat-progress-bar-buffer{
    background-color: #ECECEE;
    }`;

    this.styleElement.innerHTML = '';
    this.styleElement.type = 'text/css';
    this.styleElement.appendChild(document.createTextNode(css));
    head.appendChild(this.styleElement);

  }
  cambiaColorSatisfaccion() {
    const head = document.getElementsByTagName('head')[0];
    let css='';
    css = css+`
    .perro .mat-progress-bar-fill::after {
      background-color: #FF613A  !important;
    }
    body.temaFocusArea2 .mat-progress-bar-background{
      fill: #087272 !important;
    }`;

    this.styleElement2.innerHTML = '';
    this.styleElement2.type = 'text/css';
    this.styleElement2.appendChild(document.createTextNode(css));
    head.appendChild(this.styleElement2);
    head.appendChild(this.styleElement2);

  }

GraficaDonaConocimiento(){
  let conocimiento: number = this.conocimientoAvance.toFixed(0);

  let porcentajeFaltante=100-conocimiento;


  this.doughnutChartLabelsConocimiento= [];
  this.doughnutChartDataConocimiento= [
    [conocimiento,porcentajeFaltante]
  ];

  this.doughnutChartOptionsConocimiento = {
   responsive: true,
    tooltips:{
     enabled: false,
    }
  }

  this.donutColorsConocimiento = [
      {
        backgroundColor: [
          '#00EADF',
          '#B3F9F6',

        ],
        hoverBackgroundColor: [

          '#00EADF',
          '#B3F9F6',

          ]
      }
    ];

this.doughnutChartPluginsConocimiento= [{

       beforeDraw(chart) {
         let ctx = chart.ctx;
         let txt = 'Center Text';

         //Get options from the center object in options
         const sidePadding = 60;


         ctx.textAlign = 'center';
         ctx.textBaseline = 'middle';
         const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
         const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

         //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
         const stringWidth = ctx.measureText(txt).width;


         // Find out how much the font can grow in width.



         ctx.font ='25px Arial';
         ctx.fillStyle = '#087272';

         // Draw text in center
         ctx.fillText(conocimiento+'%', centerX, centerY);
       }
     }];







}

 GraficaDonaSatisfaccion(){
  let satisfaccion: number = this.satisfaccionAvance.toFixed(0);
  let porcentajeFaltantes=100-satisfaccion;
  this.doughnutChartLabelsSatisfaccion= [];
  this.doughnutChartDataSatisfaccion= [
    [porcentajeFaltantes,satisfaccion],
  ];
  this.doughnutChartOptionsSatisfaccion = {
   responsive: true,
    tooltips:{
     enabled: false,
    }
  }
  this.donutColorsSatisfaccion = [
      {
        backgroundColor: [
          'rgb(255, 216, 206)',
          '#FF4F2E',
        ],
        hoverBackgroundColor: [
          'rgb(255, 216, 206)',
          '#FF4F2E',
          ]
      }
    ];




 this.doughnutChartPluginsSatisfaccion=[{
      beforeDraw(chart) {
        let ctx = chart.ctx;
        let txt = 'Center Text';

        //Get options from the center object in options
        const sidePadding = 60;


        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
        const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        const stringWidth = ctx.measureText(txt).width;


        // Find out how much the font can grow in width.



        ctx.font ='25px Arial';
        ctx.fillStyle = '#FF613A';

        // Draw text in center
        ctx.fillText(satisfaccion+'%', centerX, centerY);
      }
    }];

}

 getinfo4all(){
  console.log(localStorage.getItem('productoID'));

let dato={productoId: localStorage.getItem('productoID')};

  this.resultadosService.get4allresul(dato).subscribe( (respuesta: backInter.Resultados4all) => {
  if(respuesta['success'] == true){
   this.resultados4ll=respuesta;
    console.log(this.resultados4ll);

    this.resultados4ll.resultado2.forEach(categoria => {
      let iconoFnd: string;
      this.iconosBoton.forEach(icono => {
        if(icono.nombre == categoria.demografico){
          iconoFnd = icono.icono;
        }
      });
      if(!iconoFnd){
        iconoFnd = this.iconoDefault.icono;
      }
      this.iconosFiltrados.push(iconoFnd);
    });

    this.conocimientoAvance=this.resultados4ll.totalConocimiento;
    this.satisfaccionAvance=this.resultados4ll.totalSatisfaccion;
    if (this.conocimientoAvance!=null) {
      this.datosChange=true;
    }else{
      this.datosChange=false;
    }
     this.cargando = false;

    console.log(this.conocimientoAvance);
    console.log(this.satisfaccionAvance);
    this.GraficaDonaSatisfaccion();
    this.GraficaDonaConocimiento();
    console.log("gagagag",this.datosChange);

  }
  else{
    this.cargando=false;
    let modal = 'RESULTADOS.4ALL.MODL_N_RESU';
    this.translateSrv.get(modal).subscribe((res: string) => { modal = res; });
    Swal.fire({
      title: modal,
      icon: 'warning'
    });


  }


  });
}

 getinfo4allExterno(){

let dato={productoId: this.parametroProductoId};

  this.resultadosService.get4allresulExterno(this.parametroEmpresaId,dato).subscribe( (respuesta: backInter.Resultados4all) => {
  if(respuesta['success'] == true){
   this.resultados4ll=respuesta;
    console.log(this.resultados4ll);

    this.resultados4ll.resultado2.forEach(categoria => {
      let iconoFnd: string;
      this.iconosBoton.forEach(icono => {
        if(icono.nombre == categoria.demografico){
          iconoFnd = icono.icono;
        }
      });
      if(!iconoFnd){
        iconoFnd = this.iconoDefault.icono;
      }
      this.iconosFiltrados.push(iconoFnd);
    });

    this.conocimientoAvance=this.resultados4ll.totalConocimiento;
    this.satisfaccionAvance=this.resultados4ll.totalSatisfaccion;

     this.cargando = false;

    console.log(this.conocimientoAvance);
    console.log(this.satisfaccionAvance);
    this.GraficaDonaSatisfaccion();
    this.GraficaDonaConocimiento();

  }
  else{
    this.cargando=false;
    let modal = 'RESULTADOS.4ALL.MODL_N_RESU';
    this.translateSrv.get(modal).subscribe((res: string) => { modal = res; });
    Swal.fire({
      title: modal,
      icon: 'warning'
    });


  }


  });
}

 getresultallProducVersion3(token){
  this.resultadosService.getresultallProducVer3(token).subscribe( (respuesta: backInter.Resultados4all) => {
  if(respuesta['success'] == true){
   this.resultados4ll=respuesta;
    console.log(this.resultados4ll);

    this.resultados4ll.resultado2.forEach(categoria => {
      let iconoFnd: string;
      this.iconosBoton.forEach(icono => {
        if(icono.nombre == categoria.demografico){
          iconoFnd = icono.icono;
        }
      });
      if(!iconoFnd){
        iconoFnd = this.iconoDefault.icono;
      }
      this.iconosFiltrados.push(iconoFnd);
    });

    this.conocimientoAvance=this.resultados4ll.totalConocimiento;
    this.satisfaccionAvance=this.resultados4ll.totalSatisfaccion;
    if (this.conocimientoAvance!=null) {
      this.datosChange=true;
    }else{
      this.datosChange=false;
    }
     this.cargando = false;

    console.log(this.conocimientoAvance);
    console.log(this.satisfaccionAvance);
    this.GraficaDonaSatisfaccion();
    this.GraficaDonaConocimiento();

  }
  else{
    this.cargando=false;
    let modal = 'RESULTADOS.4ALL.MODL_N_RESU';
    this.translateSrv.get(modal).subscribe((res: string) => { modal = res; });
    Swal.fire({
      title: modal,
      icon: 'warning'
    });


  }


  });
}







cambiaSeccion(numero:number){
console.log('numero',numero);

  this.seccionNumero=numero;

  this.resultados4ll.resultado2.forEach(categoria => {
    if(categoria.demograficoId == numero){
      this.segmentosSeleccionados = categoria.segmentos;
    }
  });

  this.seccionesOcultas=true;
}

}
